import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import SendNotification from "../../Modules/Notification/SendNotification";

const UserBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onBulkPublish,
  onBulkDelete,
  onExportUser,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onBulkPublish: any;
  onBulkDelete: any;
  onExportUser: any;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkPublishModal, setOpenBulkPublishModal] = useState(false);
  const [openExportUserModal, setOpenExportUserModal] = useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const [bulkPublishStatus, setBulkPublishStatus] = useState("");
  const [isEditNotification, setIsEditNotification] = useState(false);
  const [notificationObj, setNotificationObj] = useState({});

  function sendNotificationMessage() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenNotificationModal(!openNotificationModal);
  }

  function bulkPublish(status: string) {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkPublishModal(true);
    setBulkPublishStatus(status);
    let msg = t("CONFIRM_ACTION", {
      action:
        status == statusArr.active
          ? t("PUBLISH").toLowerCase()
          : t("UNPUBLISH").toLowerCase(),
      entity: t("USER").toLowerCase(),
    });
    setBulkActionMessage(msg);
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: "",
      })
    );
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("USER").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  return (
    <div className="user-action col-md-8 customer-action">
      {UtilityServices.hasPermission("send-user-notification") && (
        <Button onClick={sendNotificationMessage}>
          {t("SEND")} {t("NOTIFICATION")}
        </Button>
      )}
      {UtilityServices.hasPermission("publish-user") && (
        <React.Fragment>
          <Button onClick={() => bulkPublish("1")}>{t("PUBLISH")}</Button>
          <Button onClick={() => bulkPublish("0")}>{t("UNPUBLISH")}</Button>
        </React.Fragment>
      )}
      {UtilityServices.hasPermission("delete-user") && (
        <Button onClick={bulkDelete}>{t("DELETE")}</Button>
      )}
      {UtilityServices.hasPermission("export-user") && (
        <Button onClick={() => setOpenExportUserModal(true)}>
          {t("EXPORT")}
        </Button>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openBulkPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkPublish(bulkPublishStatus);
            setOpenBulkPublishModal(false);
          } else {
            setOpenBulkPublishModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkDelete();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openExportUserModal}
        handleClose={(e: any) => {
          if (e == true) {
            onExportUser();
            setOpenExportUserModal(false);
          } else {
            setOpenExportUserModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action: t("EXPORT").toLowerCase(),
          entity: t("USER").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("EXPORT").toLowerCase(),
        })}
      />
      <SendNotification
        openNotificationModal={openNotificationModal}
        setCheckedKeys={setCheckedKeys}
        isEditNotification={isEditNotification}
        notificationObj={notificationObj}
        setIsEditNotification={setIsEditNotification}
        setNotificationObj={setNotificationObj}
        setOpenNotificationModal={setOpenNotificationModal}
        userIds={checkedKeys}
      />
    </div>
  );
};

export default UserBulkAction;
